// 旅行状态机轮询（EP-005-S3 / GDD 02 §②-2.1 / ADR-003）。
//
// 三处必须触发 checkReturn（即 store.tick）：
//   1. 加载 / 挂载时
//   2. visibilitychange（标签页重新可见）
//   3. focus + 低频 setInterval
// setInterval **只触发重算**，绝不累加 elapsed（CI 守门 check-no-tick-accumulator）。
// 本文件在 src/core（非 domain），故 setInterval / Date.now 允许使用。
import { useGameStore } from '../store';
import { now } from './time';

export const POLL_INTERVAL_MS = 30_000;

function checkReturn(): void {
  useGameStore.getState().tick(now());
}

// 启动轮询，返回停止函数（App 卸载时调用）。
export function startStateMachine(): () => void {
  checkReturn(); // 挂载即跑一次（离线回归 / 加载即判定）

  const onVisibility = (): void => {
    if (typeof document !== 'undefined' && document.visibilityState === 'visible') checkReturn();
  };
  const onFocus = (): void => {
    checkReturn();
  };

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', onVisibility);
  }
  if (typeof window !== 'undefined') {
    window.addEventListener('focus', onFocus);
  }
  const intervalId = setInterval(checkReturn, POLL_INTERVAL_MS);

  return () => {
    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', onVisibility);
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('focus', onFocus);
    }
    clearInterval(intervalId);
  };
}
